/*global Modernizr, template_large, template_small_artist, template_small_venue, convertToDom, alert */
/*jslint browser:true */

(function() {
  'use strict';

  var lazyloads = document.querySelectorAll('.js-lazyload');
  if(lazyloads) {
    lazyloads.forEach((lazyload) => {
      var lazyload_trigger = lazyload.nextElementSibling.querySelector('a');

      lazyload.setAttribute('data-page', 1);

      lazyload_trigger.addEventListener('click', (e) => {
        e.preventDefault();

        var lazyload_form = document.getElementById('lazyload_data');
    		lazyload_form.querySelector('#lazyload-type').value = lazyload.getAttribute('data-type');
    		lazyload_form.querySelector('#lazyload-limit').value = lazyload.getAttribute('data-limit');

    		var data = do_serialize(lazyload_form);

        make_request(lazyload, data);

        lazyload.setAttribute('data-page', parseInt(lazyload.getAttribute('data-page')) + 1);
      });
    });
  }

  function populate_events(elem, data) {
    var style = elem.getAttribute('data-style');

    data.forEach((row) => {
      var row_html;

      if(style === 'large') {
        row_html = template_large(row);
      } else if(style === 'small_artist') {
        row_html = template_small_artist(row);
      } else if(style === 'small_venue') {
        row_html = template_small_venue(row);
      }

      row_html = convertToDom(row_html);

      if(row.past_event) {
        row_html.querySelector('.button').remove();
      }

      elem.appendChild(row_html);
    });

    elem.nextElementSibling.classList.add('hide');
  }

  function do_serialize(form) {
		var field,
			l,
			s = [];

		if (typeof form === 'object' && form.nodeName === "FORM") {
			var len = form.elements.length;

			for (var i = 0; i < len; i++) {
				field = form.elements[i];
				if (field.name && !field.disabled && field.type !== 'button' && field.type !== 'file' && field.type !== 'reset' && field.type !== 'submit') {
					if (field.type === 'select-multiple') {
						l = form.elements[i].options.length;

						for (var j = 0; j < l; j++) {
							if (field.options[j].selected) {
								s[s.length] = encodeURIComponent(field.name) + "=" + encodeURIComponent(field.options[j].value);
							}
						}
					}
					else if ((field.type !== 'checkbox' && field.type !== 'radio') || field.checked) {
						s[s.length] = encodeURIComponent(field.name) + "=" + encodeURIComponent(field.value);
					}
				}
			}
		}
		return s.join('&').replace(/%20/g, '+');
  }

  function make_request(elem, data) {
    elem.nextElementSibling.classList.add('loading');

    var httpRequest = new XMLHttpRequest();
		httpRequest.onreadystatechange = function (evt) {
			var resp;
			if (evt.target.readyState === XMLHttpRequest.DONE) {
				if (evt.target.status === 200) {
					resp = JSON.parse(evt.target.responseText);
					if (resp.success === true) {
            elem.nextElementSibling.classList.remove('loading');

						populate_events(elem, resp['data']);
					}
				}
			}
		};
		httpRequest.open('POST', '/lazyload', true);
		httpRequest.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');
		httpRequest.setRequestHeader('X-Requested-With', 'XMLHttpRequest');

		var cookies = document.cookie.split(';');
		for (var i = 0; i < cookies.length; i++) {
			var j = cookies[i].split('=');
			j[0] = j[0].trim();
			if (j[0] === 'csrfToken') {
				httpRequest.setRequestHeader('X-CSRF-Token', j[1]);
				break;
			}
		}
    httpRequest.send(data);
  }
}());
